// moment().day() => day of week => from 0 -> 6 with 0 is sunday, monday, ...
export const getDayOfWeek = momentDate => {
    return (momentDate.day() || 7) - 1;
}